import moment, { Moment } from "moment/moment"

export const checkEditCreationDate = (
	date: string | null,
	newDate: string | Moment | null,
	periodFrom: number,
	periodTo: number,
) => {
	const dateMonth = moment(date).format("MM")
	const dateYear = moment(date).format("YYYY")
	const newDateMonth = moment(newDate).format("MM")
	const newDateYear = moment(newDate).format("YYYY")

	if (Number(dateMonth) <= 9 && dateYear === "2023") {
		return dateMonth === newDateMonth
	} else {
		const newDateDay = +moment(newDate).format("DD")

		return (
			dateYear === newDateYear &&
			dateMonth === newDateMonth &&
			newDateDay >= periodFrom &&
			newDateDay <= periodTo
		)
	}
}

export function formatPhoneNumber(phoneNumber: number | string): string | null {
	const cleaned = String(phoneNumber).replace(/\D/g, "")
	const match = cleaned.match(/^(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})$/)

	if (match) {
		return `+${match[1]} (${match[2]})-${match[3]}-${match[4]}-${match[5]}`
	}

	return null
}

type AddressType = {
	territory: string | null
	locality: string | null
	addressType: string | null
	address: string | null
	house: string | null
	building: string | null
	apartment: string | null
	district: string | null
}

export function formatAddress<T extends AddressType>(
	order: T,
	withoutTerritory: boolean,
): string {
	const {
		territory,
		locality,
		addressType,
		address,
		house,
		building,
		apartment,
		district,
	} = order

	let formatAddress = ""
	if (territory && !withoutTerritory) {
		formatAddress += `${territory}`
	}
	if (district) {
		formatAddress += `, ${district}`
	}
	if (locality) {
		formatAddress += `, ${locality}`
	}
	if (address) {
		formatAddress += `, ${address}`
	}
	if (addressType) {
		formatAddress += ` ${addressType}`
	}
	formatAddress += `, ${house ?? "-"}`
	formatAddress += `, ${building ?? "-"}`
	formatAddress += `, ${apartment ?? "-"}`

	return formatAddress
}

type NameType = {
	name: string | null
	surname: string | null
	patronymic: string | null
}

export function formatName<T extends NameType>(order: T): string {
	const { name, surname, patronymic } = order
	let formatName = ""

	if (name) {
		formatName = `${name}`
	}
	if (surname) {
		formatName = `${surname} ` + formatName
	}
	if (patronymic) {
		formatName += ` ${patronymic}`
	}
	return formatName
}

export function formatID(order: any): string {
	return String(order.id).padStart(6, "0")
}

export function convertId(id: number): string {
	return String(id).padStart(6, "0")
}
